import { Box } from "@mui/system";
import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import {
  MICROSITE_CONNECT_ACCOUNT_FAILED,
  MICROSITE_CONNECT_ANOTHER_ACCOUNT,
  MICROSITE_CONNECT_MORE_ACCOUNTS,
  MICROSITE_CONNECT_TRY_AGAIN,
  trackEvent,
} from "../../analytics";
import { Background, DropdownMessage, FullScreenLoader, InvertedPrimaryButton, NavBar, PrimaryButton } from "../../Components";
import { ROUTE_LANDING_PAGE } from "../../Routes/RouteMapping";
import { getWorkplatformDetails } from "../../utils/api";
import { STORAGE_WORK_PLATFORM_ID, CONNECTED_STORAGE_WORK_PLATFORM_ID, STORAGE_AUTH_DATA, ERROR_PAGE_CONTENT, STORAGE_AUTH_TENANT_APP_NAME, STORAGE_WORK_PLATFORM_NAME, INSTAGRAM_WORK_PLATFORM_NAME } from "../../utils/constants";
import { launchSDK, navigateToPlatformEducationPage } from "../../utils/helpers";
import "./ErrorPage.scss";
import parse from "html-react-parser";
import Icons from "../../Components/Icons/icons";

function ErrorPage() {
  const [loader, setLoader] = useState(false);
  const navigate = useNavigate();
  const [workplatformName, setWorkplatformName] = useState("");

  const [appName, setAppName] = useState();
  const onlyOnce = useRef(true);
  useEffect(() => {
    (async () => {
      const auth = JSON.parse(sessionStorage.getItem(STORAGE_AUTH_DATA));
      const workPlatformName = sessionStorage.getItem(STORAGE_WORK_PLATFORM_NAME);
      setWorkplatformName(workPlatformName)
      let response;
      if (onlyOnce.current) {
        onlyOnce.current = false;
        trackEvent(MICROSITE_CONNECT_ACCOUNT_FAILED, { creator_user_id: auth?.user_id, work_platform_name: response?.name });
      }
      setAppName(auth[STORAGE_AUTH_TENANT_APP_NAME]);
    })();
  }, []);
       if(loader) return <FullScreenLoader showLoader={loader} />
  return (
    <>
      <Background>
        <Box className="error-page-body" >
          <Box className="error-page-header" >
            <label> {ERROR_PAGE_CONTENT.header} </label>
            <Box className="circular-icon" > {ERROR_PAGE_CONTENT.icon} </Box>
          </Box>
          {workplatformName && workplatformName === INSTAGRAM_WORK_PLATFORM_NAME && <Box className="error-page-content" >
            {Object.entries(ERROR_PAGE_CONTENT?.instaErrorContent).map(([key, content]) => (
              <Box key={key}>
                <DropdownMessage content={content} index={+key + 1} />
              </Box>
            ))}
          </Box>}
          {workplatformName && workplatformName !== INSTAGRAM_WORK_PLATFORM_NAME && <Box className="error-page-content">
            {Object.entries(ERROR_PAGE_CONTENT?.otherPlatformErrorContent).map(([key, content]) => (
              <Box key={key}>
                <DropdownMessage content={content} index={+key + 1} />
              </Box>
            ))}
          
          </Box>}
          <Box className="contact-info" >
            {ERROR_PAGE_CONTENT?.contactInfo?.map((data, index) => (
              <p key={index}> {parse(data.replace("appName", appName))} </p>
            ))}
          </Box>
          <Box className="button-group">
            <PrimaryButton
              label={"Try again"}
              onClick={() => {
                trackEvent(MICROSITE_CONNECT_TRY_AGAIN, { work_platform_name: workplatformName });
                navigateToPlatformEducationPage(navigate);
              }}
            />
            <InvertedPrimaryButton
              label={<> <Icons.add_other_platforms/> Connect another account</>}
              onClick={() => {
                trackEvent(MICROSITE_CONNECT_ANOTHER_ACCOUNT, { work_platform_name: workplatformName });
                navigate(ROUTE_LANDING_PAGE);
              }}
            />
          </Box>
        </Box>
      </Background>
    </>
  );
}

export default ErrorPage;
